import React, { useEffect, useState } from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";
import TestimoniCard from "./TestimoniCard";
import {TestimoniOne, TestimoniTwo} from "../../assets";

const testimonials = [
  {
    id: 1,
    name: "Ravi Satya Salman",
    city: "JAKARTA",
    image: TestimoniOne,
    imagePosition: "center 95%",
    imagePositionTablet: "center 100%",
    imagePositionMobile: "center 86%",
    scoreImprovement: "5.5 ➤ 8.0 | LPDP",
    acceptance: ["Academic"],
    scholarship: ["Singapura", "Australia"],
    quote:
      "Saya merasa terbantu banget dengan kakak tutor. Dengan frekuensi belajar 5 sampai 6 kali seminggu, Saya jadi bisa liat dimana kelemahan saya sehingga bisa belajar dengan fokus. Selain itu. Kakak tutor juga bantu saya jadi terasa motivated dan bisa belajar sambil terjaga mentalnya.",
  },
  {
    id: 2,
    name: "Deni Yunus Wijaya",
    city: "DEPOK",
    image: TestimoniTwo,
    imagePosition: "center 70%",
    imagePositionTablet: "center 66%",
    imagePositionMobile: "center 74%",
    scoreImprovement: "5.5 to 7.0",
    acceptance: ["Academic"],
    scholarship: ["AAS", "MANAAKI NZ"],
    quote:
      "The roadmap was clear and the feedback was detailed. With learning twice every week I knew exactly what to improve, and that made my progress feel consistent.",
  }//,
  // {
  //   id: 3,
  //   name: "Eunbi Putri",
  //   city: "SURABAYA",
  //   image: TestimoniThree,
  //   imagePosition: "center 28%",
  //   imagePositionTablet: "center 24%",
  //   imagePositionMobile: "center 22%",
  //   scoreImprovement: "6.5 to 8.0",
  //   acceptance: ["University of Melbourne", "Monash University"],
  //   scholarship: ["LPDP", "Austalia Awards"],
  //   quote:
  //     "What I loved most was the mentoring tone. It felt personal and strategic at the same time, so I was better prepared for every stage.",
  // },
];

export default function Testimonials() {
  const [activeIndex, setActiveIndex] = useState(0);
  const [expandedId, setExpandedId] = useState(null);
  const [direction, setDirection] = useState("next");
  const [isHoverPaused, setIsHoverPaused] = useState(false);

  const goToNext = () => {
    setDirection("next");
    setExpandedId(null);
    setActiveIndex((prev) => (prev + 1) % testimonials.length);
  };

  const goToPrev = () => {
    setDirection("prev");
    setExpandedId(null);
    setActiveIndex((prev) => (prev - 1 + testimonials.length) % testimonials.length);
  };

  const toggleExpanded = (id) => {
    setExpandedId((prev) => (prev === id ? null : id));
  };

  useEffect(() => {
    if (expandedId !== null || isHoverPaused) {
      return;
    }

    const intervalId = setInterval(() => {
      setDirection("next");
      setActiveIndex((prev) => (prev + 1) % testimonials.length);
    }, 4200);

    return () => clearInterval(intervalId);
  }, [expandedId, isHoverPaused]);

  return (
    <section id="testimonials" className="bg-[--st-color-navy] px-4 py-14 sm:px-6 sm:py-16 lg:px-8 lg:py-20">
      <div className="mx-auto w-full max-w-[1240px]">
        <div className="mb-8 grid gap-4 sm:mb-10 md:grid-cols-[1fr_auto] md:items-end">
          <p className="st-font-body st-text-cream max-w-[500px] text-[32px] leading-[1.22]">
            Mereka pernah di posisi kamu dan berhasil!
          </p>

          <div className="text-left md:text-right">
            <h2 className="st-font-display text-[52px] leading-none text-[var(--st-color-testi-heading)] sm:text-[68px]">
              <span className="italic font-normal">What did</span> <span className="font-bold">they say?</span>
            </h2>
          </div>
        </div>

        <div
          className="relative overflow-visible"
          onMouseEnter={() => setIsHoverPaused(true)}
          onMouseLeave={() => setIsHoverPaused(false)}
        >
          <button
            type="button"
            onClick={goToPrev}
            className="st-testi-nav st-testi-side-nav left-[-10px] hidden md:inline-flex lg:left-[-18px] translate-x-[-8px] translate-y-[-12px]"
            aria-label="Previous testimonial"
          >
            <ChevronLeft size={20} />
          </button>

          <div
            key={`${testimonials[activeIndex].id}-${direction}`}
            className={`animate-[stTestiIn_420ms_cubic-bezier(0.22,1,0.36,1)] ${
              direction === "next" ? "[--st-offset:26px]" : "[--st-offset:-26px]"
            }`}
            style={{
              animationName: "stTestiIn",
            }}
          >
            <TestimoniCard
              data={testimonials[activeIndex]}
              expanded={expandedId === testimonials[activeIndex].id}
              onToggle={() => toggleExpanded(testimonials[activeIndex].id)}
            />
          </div>

          <button
            type="button"
            onClick={goToNext}
            className="st-testi-nav st-testi-side-nav right-[-10px] hidden md:inline-flex lg:right-[-18px] translate-x-[8px] translate-y-[-12px]"
            aria-label="Next testimonial"
          >
            <ChevronRight size={20} />
          </button>
        </div>

        <div className="mt-4 flex items-center justify-between sm:hidden">
          <button
            type="button"
            onClick={goToPrev}
            className="st-testi-nav"
            aria-label="Previous testimonial"
          >
            <ChevronLeft size={20} />
          </button>

          <div className="st-font-body st-text-cream text-[12px] tracking-[0.2em]">
            {String(activeIndex + 1).padStart(2, "0")} / {String(testimonials.length).padStart(2, "0")}
          </div>

          <button
            type="button"
            onClick={goToNext}
            className="st-testi-nav"
            aria-label="Next testimonial"
          >
            <ChevronRight size={20} />
          </button>
        </div>
      </div>
    </section>
  );
}
